import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class Report401kpaymentService {
  private _report401kurl = CONFIGURATION.baseServiceUrl + '401k-payments/';
  private _ssnUrl = CONFIGURATION.baseServiceUrl + 'SsnInfo/';
  constructor(private _http: Http) { }

  getReportData(): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this._report401kurl + 'reference-data', { headers: headers })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }

  get401kreportData(data: any): Observable<any> {
    console.log(data)
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this._report401kurl + 'report-data?ControlGroup=' + data.ControlGroup + '&ProdCoName=' + data.productionCompany + '&StartDate=' + data.startDate + '&EndDate=' + data.endDate, { headers: headers })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }

  downloadExcelReport(oData: any): any {
    const fileName = 'excel-download?ControlGroup=' + oData.ControlGroup
      + '&ProdCoName=' + oData.productionCompany + '&StartDate=' + oData.startDate + '&EndDate=' + oData.endDate;
    const url = this._report401kurl + fileName
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
      (res) => {
        const a = document.createElement('a');
        document.body.appendChild(a);
        const blob = new Blob([res.blob()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const downloadUrl = URL.createObjectURL(blob);
        window.open(downloadUrl);
      })

  }
  private handleError(error: Response) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
  }

}




// WEBPACK FOOTER //
// ./src/app/401kpayments/Report401kpayment.service.ts